import { Component } from '@angular/core';

@Component({
  selector: 'app-leads-report',
  templateUrl: './leads-report.component.html',
  styleUrls: ['./leads-report.component.scss']
})
export class LeadsReportComponent {
   reports = [
  {
    name: "Lead Generation Overview",
    description: "Displays all leads generated today, yesterday, last week, last month, and last year, providing a quick overview of lead generation performance.",
    lastAccessed: "Yesterday",
    slug: "todays-leads"
  },
  {
    name: "Leads by Status",
    description: "Categorizes leads based on their current status, such as New, Contacted, Qualified, or Disqualified.",
    lastAccessed: "Yesterday",
    slug: "leads-by-status"
  },
  {
    name: "Leads by Source",
    description: "Breaks down lead acquisition by source, such as website, social media, events, or referrals.",
    lastAccessed: "18/04/2025",
    slug: "leads-by-source"
  },
  {
    name: "Leads by Ownership",
    description: "Organizes leads by assigned owner, allowing managers to track team performance and workload distribution.",
    lastAccessed: "18/04/2025",
    slug: "leads-by-ownership"
  },
  {
    name: "Converted Leads",
    description: "Shows leads that have been successfully converted into Accounts, Deals, or Contacts, including conversion date and assigned user.",
    lastAccessed: "18/04/2025",
    slug: "converted-leads"
  },
  {
    name: "Call Log Report",
    description: "Show all leads that have been called based on the selected date range and lead ownership filters.",
    lastAccessed: "18/04/2025",
    slug: "call-log-report"
  },
  {
    name: "Email Log Report",
    description: "Show all leads that have been emailed based on the selected date range and lead ownership filters.",
    lastAccessed: "18/04/2025",
    slug: "email-log-report"
  },
];

}
